import React, { Component } from 'react';
import ReactTooltip         from 'react-tooltip';
import { connect }          from 'react-redux';

class BtLikeNave extends Component {
    render() {
    
        const vetor    = this.props.vetor;
        const likes    = this.props.all_posts_nave[vetor].num_like;
        const use_like = this.props.all_posts_nave[vetor].like_usuario;
        const pos_id   = this.props.all_posts_nave[vetor].tur_pos_id;
       
        return (
                    <button 
                        type              = "button"
                        data-tip data-for = {'like_'}
                        onClick           = {this.props.funcao}
                        id                = {`like_${pos_id}`}
                        className         = {use_like > 0 ? "btn btn-xs btn-link like colorRedLike":"btn btn-xs btn-link like colorRedDesLike"}>
                        <span className   = "glyphicon glyphicon-heart"></span>
                        <span className   = "countLike" id={`icon_like_${pos_id}`}>
                        { likes === 0 ? null : likes }
                        </span>
                        <ReactTooltip 
                            id     = {'like_'}
                            type   = 'dark'
                            effect = 'solid'>
                            <span>Like</span>
                        </ReactTooltip>
                    </button>
        );
    }
}

function  mapStateToProps(state){

    return { all_posts_nave : state.turmaReducer.all_posts}
}

export default connect(mapStateToProps)(BtLikeNave);


 





// WEBPACK FOOTER //
// ./src/container/bt_like_timeline_turma.js